export default {
  TableHeadSecretPassword: [
    [
      {
        displayName: 'secret_password.secret_password_table_head.source',
      },
      {
        displayName: 'secret_password.secret_password_table_head.username',
      },
      {
        displayName: 'secret_password.secret_password_table_head.role',
      },
      {
        displayName: 'secret_password.secret_password_table_head.edit',
      },
      {
        displayName: 'secret_password.secret_password_table_head.log',
      },
    ],
  ],
};
